import { createContext, useContext } from 'react';

/** Lines of a file to show: a citation, a search hit, a finding, a caller. */
export interface CodeTarget {
  path: string;
  start: number;
  end: number;
}

/** What every section of one repository's workspace shares. */
export interface Workspace {
  linkId: string;
  projectId: string;
  /** Opens the side panel with the code at these lines, keeping the section as it is. */
  openCode: (target: CodeTarget) => void;
  /** The Files tab at this file (and lines): the URL holds the path and line numbers only, never code. */
  filesHref: (target: { path: string; start?: number; end?: number }) => string;
}

export const WorkspaceContext = createContext<Workspace | null>(null);

export function useWorkspace(): Workspace {
  const workspace = useContext(WorkspaceContext);
  if (!workspace) {
    throw new Error('useWorkspace must be used inside a repository workspace');
  }
  return workspace;
}
